import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';

import { bulkProjects } from 'common/api/v1/projects';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';
import showToast from 'common/utils/showToast';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
} from '../actionTypes';
import { projectsActions } from '../reducer';

import filterContacts from './filterProjects';

export default (ids, value, filterData, callback) => (dispatch) => {
    dispatch(projectsActions[BULK_UPDATE_ITEMS]());

    const newValues = {
        status_flag: value,
        projects: ids,
    };

    bulkProjects(newValues)
        .then((response) => {
            dispatch(projectsActions[BULK_UPDATE_ITEMS_SUCCESS](response.data));
            if (!isEmpty(filterData)) dispatch(filterContacts(filterData));
            if (value === 'deleted')
                showToast({ body: i18next.t('It was successfully removed') });
            if (value === 'archived')
                showToast({ body: i18next.t('It was successfully archived') });
            if (value === 'active')
                showToast({
                    body: i18next.t('It was successfully unarchived'),
                });
            if (callback) callback();
        })
        .catch((error) => {
            dispatch(
                projectsActions[BULK_UPDATE_ITEMS_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
